export default "__VITE_ASSET__1b3913b8__"